import { createAction, props } from '@ngrx/store';
import { IntegrationsState } from './reducer';

export const UPDATE_INTEGRATIONS_STATUS = '[Integrations] Update Integrations Status';
export const UpdateIntegrationsStatusAction = createAction(
    UPDATE_INTEGRATIONS_STATUS,
    props<{ payload: IntegrationsState 
}>());
